<app-weekly-summary
[code]="code"
></app-weekly-summary>

